import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useFieldMode, getEffectiveFieldMode } from './FieldModeContext';

type RequireAuthProps = {
  children: React.ReactNode;
  role?: 'admin' | 'technician';
};

export default function RequireAuth({ children, role }: RequireAuthProps) {
  const { user, loading } = useAuth();
  const { fieldMode } = useFieldMode();
  const location = useLocation();
  const effectiveFieldMode = getEffectiveFieldMode(fieldMode);

  if (loading) {
    return <div style={{ padding: '40px', textAlign: 'center' }}>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const resolvedUserRole = typeof user.role === 'string' ? user.role.trim().toLowerCase() : '';
  const resolvedRequiredRole = typeof role === 'string' ? role.trim().toLowerCase() : '';

  if (role && resolvedUserRole !== resolvedRequiredRole) {
    if (resolvedRequiredRole === 'technician' && resolvedUserRole === 'admin') {
      if (effectiveFieldMode) {
        return <>{children}</>;
      }
      return <Navigate to="/admin/dashboard" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
